import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import Elipses from "../../components/Elipses";
import BlogCards from "./blogCards/blogCards";
import { blogPosts } from "../../data/blogPosts";

function AllPosts() {
	useEffect(() => {
		window.scrollTo(0, 0);
		document.title = "Blog | Zealight Innovation Labs";
	}, []);

	return (
		<Box data-aos="fade-up" marginBottom="80px" padding={["2rem 2rem", "5.5rem 6rem"]}>
			<Elipses />
			<Stack>
				<Stack my="50px" p={["20px", "60px"]} justifyContent={"center"} alignItems="center">
					<Stack direction={"row"} alignItems="flex-end">
						<Heading fontFamily={"Trenda-heavy"} fontSize="4em" color="#290F44">
							BLOG
						</Heading>
						<Box w="15px" h="15px" borderRadius={"50%"} bg="#00FE98" mb="20px !important" />
					</Stack>

					<Text maxW={"450px"} textAlign="center" fontSize={"1.2em"}>
						Sharing our thought and perspectives on the innovations and technologies we use
					</Text>
				</Stack>
			</Stack>

			{blogPosts.length > 0 ? (
				<BlogCards blogs={blogPosts} vertical />
			) : (
				<Text textAlign="center" fontSize="1.2em" mt="50px">
					No blog posts available at the moment.
				</Text>
			)}
		</Box>
	);
}

export default AllPosts;
